


























































































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Dress } from '../../types/dresses'
import { deleteDress } from '../../utils/http-client/dress-api'
import Images from '../../components/Images.vue'
import DressForm from '../../components/DressComponents/DressForm.vue'
import UserBus from '@/utils/buses/UserBus'

@Component({
  components: {
    Images,
    DressForm
  }
})
export default class DressDetails extends Vue {
  @Prop({ default: {} })
  dress!: Dress
  private canEditDress: boolean = false
  private canDeleteDress: boolean = false
  private isDeleting: boolean = false
  private showDressForm: boolean = false

  get videoUrls () {
    return this.dress.imageurls.filter(i => i.indexOf('.m') > 0)
  }

  get imageUrls () {
    return this.dress.imageurls.filter(i => i.indexOf('.m') === -1)
  }

  async mounted () {
    this.setPermissions()

    UserBus.$on('user-update', this.setPermissions)
  }
  beforeDestroy () {
    // remove event listener to prevent memory leaks
    UserBus.$off('user-update', this.setPermissions)
  }

  private async onDeleteDress () {
    this.isDeleting = true

    try {
      await deleteDress(this.dress!.id!)
    } catch (err) {

    } finally {
      this.isDeleting = false
    }
    this.$emit('reload-data')
  }

  // TODO - find better way to handle permissions
  private setPermissions () {
    const designerId = Number(this.$route.params.id)
    this.canEditDress = UserBus.userIsDesigner(designerId)
    this.canDeleteDress = UserBus.userIsDesigner(designerId)
  }
}
